var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3H5C2.2385 3 0 5.2385 0 8V27C0 29.7615 2.2385 32 5 32H24C26.7615 32 29 29.7615 29 27V12.5H27V27C27 27.7956 26.6839 28.5587 26.1213 29.1213C25.5587 29.6839 24.7956 30 24 30H5C4.20435 30 3.44129 29.6839 2.87868 29.1213C2.31607 28.5587 2 27.7956 2 27V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H19.5V3Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 11.4785H15.5V23.477H13.5V11.4785Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.686H12V21.1815H10V13.686ZM17 13.686H19V21.1815H17V13.686Z",
    fill: "#0156F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12.2146H22.5V22.7121H20.5V12.2146ZM6.5 12.2146H8.5V22.7121H6.5V12.2146Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14H26V13C26 10.2405 28.24 8 31 8H32V6H31C28.24 6 26 3.7595 26 1V0H24V1C24 3.749 21.775 5.9825 19.035 6H18V8H19C21.76 8 24 10.2405 24 13V14ZM25 4.6055C24.4084 5.58666 23.5863 6.40861 22.605 7C23.5863 7.59139 24.4084 8.41334 25 9.3945C25.5916 8.41334 26.4137 7.59139 27.395 7C26.4137 6.40861 25.5916 5.58666 25 4.6055Z",
    fill: "#0156F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerative);
export default __webpack_public_path__ + "static/media/generative.aa18eac95e16e0450bf34ec65c7fc179.svg";
export { ForwardRef as ReactComponent };